/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CashflowReportResponse } from '../models/CashflowReportResponse';
import type { OverdueReportResponse } from '../models/OverdueReportResponse';
import type { PaginatedTransactionStatementResponse } from '../models/PaginatedTransactionStatementResponse';
import type { PaymentChannelStatementResponse } from '../models/PaymentChannelStatementResponse';
import type { ProfitLossContractReportResponse } from '../models/ProfitLossContractReportResponse';
import type { ProfitLossTransactionReportResponse } from '../models/ProfitLossTransactionReportResponse';
import type { SumAcceptPaymentReportResponse } from '../models/SumAcceptPaymentReportResponse';
import type { SumDisbursedLoanReportResponse } from '../models/SumDisbursedLoanReportResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ShopPawningReportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PaginatedTransactionStatementResponse OK
     * @throws ApiError
     */
    public transactionStatement({
        shopId,
        page,
        perPage,
        startDate,
        endDate,
        paymentChannelType,
    }: {
        shopId: string,
        page: number,
        perPage: number,
        startDate: string,
        endDate: string,
        paymentChannelType?: string,
    }): CancelablePromise<PaginatedTransactionStatementResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/transaction-statement',
            path: {
                'shopId': shopId,
            },
            query: {
                'page': page,
                'perPage': perPage,
                'startDate': startDate,
                'endDate': endDate,
                'paymentChannelType': paymentChannelType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ProfitLossTransactionReportResponse OK
     * @throws ApiError
     */
    public profitLossTransactionReport({
        shopId,
        year,
    }: {
        shopId: string,
        year: number,
    }): CancelablePromise<ProfitLossTransactionReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/profit-loss-transaction-report',
            path: {
                'shopId': shopId,
            },
            query: {
                'year': year,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ProfitLossContractReportResponse OK
     * @throws ApiError
     */
    public profitLossContractReport({
        shopId,
        year,
    }: {
        shopId: string,
        year: number,
    }): CancelablePromise<ProfitLossContractReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/profit-loss-pawning-contract-report',
            path: {
                'shopId': shopId,
            },
            query: {
                'year': year,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaymentChannelStatementResponse OK
     * @throws ApiError
     */
    public paymentChannelStatement({
        shopId,
        startDate,
        endDate,
        paymentChannelType,
    }: {
        shopId: string,
        startDate: string,
        endDate: string,
        paymentChannelType?: string,
    }): CancelablePromise<PaymentChannelStatementResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/payment-channel-statement',
            path: {
                'shopId': shopId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'paymentChannelType': paymentChannelType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns OverdueReportResponse OK
     * @throws ApiError
     */
    public overdueReport({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<OverdueReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/overdue-report',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SumDisbursedLoanReportResponse OK
     * @throws ApiError
     */
    public disbursedLoadReport({
        shopId,
        startDate,
        endDate,
    }: {
        shopId: string,
        startDate: string,
        endDate: string,
    }): CancelablePromise<SumDisbursedLoanReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/disbursed-loan-report',
            path: {
                'shopId': shopId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns CashflowReportResponse OK
     * @throws ApiError
     */
    public cashFlowReport({
        shopId,
        startDate,
        endDate,
    }: {
        shopId: string,
        startDate: string,
        endDate: string,
    }): CancelablePromise<CashflowReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/cash-flow-report',
            path: {
                'shopId': shopId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SumAcceptPaymentReportResponse OK
     * @throws ApiError
     */
    public acceptPaymentReport({
        shopId,
        startDate,
        endDate,
    }: {
        shopId: string,
        startDate: string,
        endDate: string,
    }): CancelablePromise<SumAcceptPaymentReportResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shops/{shopId}/pawning/accept-payment-report',
            path: {
                'shopId': shopId,
            },
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
